import { Provider } from '@angular/core';

import { UserRepositoryImpl } from '@app/data/repositories/user/user.repository';
import { USER_REPOSITORY } from '@app/domain/repositories/user/user.repository.contract';

export const userRepositoryProvider: Provider = {
  provide: USER_REPOSITORY,
  useClass: UserRepositoryImpl
};
